module.exports = __webpack_public_path__ + "richaccount.svg?f3a6037c37c18a981c96b6e03895c154";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/richaccount.svg
// module id = 249
// module chunks = 0